import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';

import DynamicContent from 'components/NewHome/DynamicContent';
import ProductTable from 'components/NewHome/ProductTable';
import MobileStatusCard, { StatusTab } from 'components/NewHome/Mobile/MobileStatusCard';
import { selectTokenUserName } from 'redux/reducers/authReducer';

import './index.scss';

export default function MobileHome() {
  const userName = useSelector(selectTokenUserName);
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const initialTab: StatusTab = searchParams.get('tab') === 'warnings' ? 'warnings' : 'meteo';

  return (
    <div className="mobile-home">
      <p className="mobile-home-greeting">
        Bem-vindo de volta,
        {' '}
        <b>{userName}</b>
      </p>
      <DynamicContent />
      <ProductTable />
      <MobileStatusCard initialTab={initialTab} activationKey={location.key} />
    </div>
  );
}
